import { IOProps } from 'react-compose-io'
import { FormFieldsProps } from '../../../types/regraApiType'
import { FieldsTipoParametroTransformacaoApi } from '../FieldsTipoParametroTransformacaoApi'
import { FieldsTipoLancamentoTransformacaoApiIO } from './FieldsTipoLancamentoTransformacaoApi.IO'

export type FieldsTipoLancamentoTransformacaoApiProps = {
  indexItensRegraForm: number
  itensCampo: FormFieldsProps[]
  cabecalhos: string[]
}
export function FieldsTipoLancamentoTransformacaoApiView({
  _io,
  indexItensRegraForm,
  itensCampo,
  cabecalhos
}: IOProps<FieldsTipoLancamentoTransformacaoApiIO, FieldsTipoLancamentoTransformacaoApiProps>) {
  return (
    <>
      {_io.acaoSelecionada[indexItensRegraForm]?.operacaoId === 'TipoLancamentoOperacao' && (
        <FieldsTipoParametroTransformacaoApi
          itensCampo={itensCampo}
          control={_io.control}
          cabecalhos={cabecalhos}
          indexItensRegraForm={indexItensRegraForm}
          itensRegraTransformacaoForm={_io.acaoSelecionada}
        />
      )}
    </>
  )
}
